import { useParams } from "react-router";
import $api from "./openapi";
import toast from "react-hot-toast";
import { useQueryClient } from "@tanstack/react-query";
import { components } from "../ApiSchema";

export default function useUpdateTimeCostPreset() {
  const { teamSlug } = useParams();
  const queryClient = useQueryClient();

  const { mutate } = $api.useMutation(
    "post",
    "/api/teams/{team_slug}/time_cost_preset",
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["get", "/api/teams/{team_slug}/time_cost_preset"],
        });
      },
      onError: ({ detail }) =>
        toast.error(detail, {
          className: "whitespace-pre-wrap",
        }),
    },
  );

  return (
    payload: components["schemas"]["TimeCostPresetCreateUpdateSchema"][],
  ) =>
    mutate({
      params: {
        path: { team_slug: teamSlug! },
      },
      body: payload,
    });
}
